import { Tabs } from 'antd';
import { Outlet } from 'react-router-dom';

import Page from '../components/Page';
import PageTitle from '../components/PageTitle';

const CreateOpportunityNavigator = () => {
  return (
    <Page>
      <PageTitle
        title="Nova Vaga"
        footer={
          <Tabs
            activeKey="general"
            items={[
              { key: 'general', label: 'Geral' },
              { key: 'profile', label: 'Perfil', disabled: true },
              { key: 'description', label: 'Descrição da vaga', disabled: true },
              { key: 'stages', label: 'Fluxo de etapas', disabled: true },
              { key: 'publication', label: 'Publicação', disabled: true },
            ]}
          />
        }
      />
      <Outlet />
    </Page>
  );
};

export default CreateOpportunityNavigator;
